import React from 'react';
import { Phone, Mail, MessageCircle } from 'lucide-react';
import { psychologistInfo } from '../data/mock';
import AppointmentContactForm from './AppointmentContactForm';

const AppointmentSection = () => {
  return (
    <section id="appointment" className="py-16 md:py-24 bg-sand-50 section-contrast">
      <div className="container mx-auto px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-12 items-center">
          {/* Left Side - Contact Info */}
          <div className="space-y-8">
            <div>
              <p className="text-teal-600 font-medium tracking-[0.3em] uppercase text-xs mb-2">
                Запись
              </p>
              <h2 className="text-3xl md:text-4xl font-serif text-stone-800 mb-4">
                Запишитесь на приём
              </h2>
              <p className="text-stone-600 leading-relaxed">
                Оставьте заявку в месенджерах или на сайте, и я свяжусь с вами в течение 24 часов.
              </p>
            </div>

            <div className="space-y-3">
              <div className="grid sm:grid-cols-2 gap-3">
                <a
                  href={psychologistInfo.social.telegram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-sky-500 text-white px-5 py-4 rounded-2xl shadow-sm hover:bg-sky-600 transition-colors"
                >
                  <MessageCircle size={20} />
                  <span className="font-medium">Telegram</span>
                </a>
                <a
                  href={psychologistInfo.social.whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2 bg-green-500 text-white px-5 py-4 rounded-2xl shadow-sm hover:bg-green-600 transition-colors"
                >
                  <MessageCircle size={20} />
                  <span className="font-medium">WhatsApp</span>
                </a>
              </div>

              <div className="flex items-center gap-4 bg-white border border-sand-200 rounded-2xl p-4 shadow-sm">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center">
                  <Phone className="text-teal-600" size={20} />
                </div>
                <div>
                  <p className="text-stone-500 text-sm">Телефон</p>
                  <a href={`tel:${psychologistInfo.phone}`} className="text-stone-800 font-semibold hover:text-teal-600">
                    {psychologistInfo.phone}
                  </a>
                </div>
              </div>
              <div className="flex items-center gap-4 bg-white border border-sand-200 rounded-2xl p-4 shadow-sm">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center">
                  <Mail className="text-teal-600" size={20} />
                </div>
                <div>
                  <p className="text-stone-500 text-sm">Email</p>
                  <a href={`mailto:${psychologistInfo.email}`} className="text-stone-800 font-semibold hover:text-teal-600">
                    {psychologistInfo.email}
                  </a>
                </div>
              </div>
            </div>

            {/* Image */}
            <div className="relative rounded-2xl overflow-hidden shadow-lg hidden md:block">
              <img
                src="/images/appointment-photo.webp"
                alt="Консультация"
                width="800"
                height="250"
                loading="lazy"
                decoding="async"
                className="w-full h-[250px] object-cover"
              />
            </div>
          </div>

          {/* Right Side - Form */}
          <AppointmentContactForm idPrefix="home-appointment" />
        </div>
      </div>
    </section>
  );
};

export default AppointmentSection;
